import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { BeforeAfterSlider } from './BeforeAfterSlider';
import { galleryProjects } from '../data/gallery';
export function GallerySection() {
  const [activeId, setActiveId] = useState(galleryProjects[0].id);
  const active = galleryProjects.find(project => project.id === activeId) ?? galleryProjects[0];
  return <section id="work" aria-labelledby="work-heading" className="bg-ink py-20 text-white lg:py-28" data-id="element-138" data-mp="5wcl0jy0dx3t">
      <div className="mx-auto max-w-7xl px-6 lg:px-8" data-id="element-139" data-mp="9xy2kilhmzkc">
        <div className="grid gap-6 lg:grid-cols-2 lg:items-end lg:gap-16" data-id="element-140" data-mp="9wept1z1j6nb">
          <div data-id="element-141" data-mp="eppm4968850z">
            <p className="mb-3 text-sm font-semibold text-white/70" data-id="element-142" data-mp="ep7u5oqlkcyv">Our work</p>
            <h2 id="work-heading" className="font-display text-3xl font-bold tracking-tight sm:text-4xl" data-id="element-143" data-mp="jmps6k32t7s3">
              See the difference.
            </h2>
          </div>
          <p className="text-lg leading-relaxed text-white/75" data-id="element-144" data-mp="tlp369bbdfi9">
            Real repairs from our shop floor. Drag the slider to compare each vehicle before and after.
          </p>
        </div>

        <div className="mt-14 grid gap-10 lg:grid-cols-12 lg:gap-12" data-id="element-145" data-mp="p83xz2x1qp1h">
          <div className="lg:col-span-8" data-id="element-146" data-mp="p9x7cpz1nnd6">
            <motion.div key={active.id} initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.2,
            ease: [0.23, 1, 0.32, 1]
          }} data-id="element-147" data-mp="k87vj83zz5o1">
              <BeforeAfterSlider before={active.before} after={active.after} label={active.vehicle} data-id="element-148" data-mp="1cwdebpbhqkl8" />
              <div className="mt-6 grid gap-2 sm:grid-cols-[1fr_auto] sm:gap-8" data-id="element-149" data-mp="17zmz147ift0v">
                <div data-id="element-150" data-mp="136tvgjns2qqd">
                  <h3 className="font-display text-xl font-bold tracking-tight" data-id="element-151" data-mp="136alpq8a78nf">{active.title}</h3>
                  <p className="mt-2 max-w-2xl leading-relaxed text-white/70" data-id="element-152" data-mp="z58mh9ed6wlg">{active.description}</p>
                </div>
                <p className="text-sm text-white/60 sm:text-right" data-id="element-153" data-mp="1vq0tf1dki3ym">
                  <span className="block font-semibold text-white" data-id="element-154" data-mp="1qwee11g0rlz4">{active.vehicle}</span>
                  {active.service}
                </p>
              </div>
            </motion.div>
          </div>

          <div className="lg:col-span-4" data-id="element-155" data-mp="3q2tjs93ou7ov">
            <p className="text-sm font-medium text-white/60" data-id="element-156" data-mp="3q5zb7uzshlnr">Recent projects</p>
            <ul className="mt-4 grid grid-cols-2 gap-3 lg:grid-cols-1" data-id="element-157" data-mp="3bd5s7zlb6nec">
              {galleryProjects.map(project => {
              const isActive = project.id === active.id;
              return <li key={project.id} data-id="element-158" data-mp="32gwtkn55nst9">
                    <button type="button" onClick={() => setActiveId(project.id)} aria-pressed={isActive} className={`flex w-full items-center gap-4 rounded-lg border p-2.5 text-left transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white ${isActive ? 'border-white/40 bg-white/10' : 'border-white/10 hover:border-white/25 hover:bg-white/5'}`} data-id="element-159" data-mp="37dwxosig2lhq">
                      <img src={project.after} alt="" className="hidden aspect-[3/2] w-20 shrink-0 rounded object-cover sm:block" data-id="element-160" data-mp="2b7tnq2izoqtn" />
                      <span className="min-w-0" data-id="element-161" data-mp="2l3n8282y9olz">
                        <span className="block truncate text-sm font-semibold text-white" data-id="element-162" data-mp="2ywctobekgrik">{project.title}</span>
                        <span className="block truncate text-sm text-white/60" data-id="element-163" data-mp="2uvkmdnp98wox">{project.vehicle}</span>
                      </span>
                    </button>
                  </li>;
            })}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}